import {
  HabitSortingMode,
  ID,
  Task,
  TaskPriorityOptions,
  WeekDays,
} from '@griply/types';

import { getSortedTasks } from './get-sorted-tasks';
import {
  groupTasksByPriority,
  PriorityGroupedTasks,
} from './group-tasks-by-priority';
import { habitSortingModeToSortingMode } from './habit-sorting-mode-to-sorting-mode';

export type BuildPriorityHabitSectionsOptions = {
  habits: Task[];
  habitSortingMode?: HabitSortingMode;
  habitGroupSorting?: Record<string, ID[]> | null;
  today: Date;
  weekStartsOn: WeekDays;
};

export const buildPriorityHabitSections = (
  options: BuildPriorityHabitSectionsOptions,
): PriorityGroupedTasks[] => {
  const { habits, habitSortingMode, habitGroupSorting, today, weekStartsOn } =
    options;

  const groups = groupTasksByPriority({ tasks: habits });

  return groups.map<PriorityGroupedTasks>((group) => ({
    ...group,
    tasks: getSortedTasks(group.tasks, {
      today,
      weekStartsOn,
      mode: habitSortingMode
        ? [habitSortingModeToSortingMode[habitSortingMode]]
        : undefined,
      order: habitGroupSorting?.[group.priority as TaskPriorityOptions] ?? [],
    }),
  }));
};
